export default __webpack_public_path__ + "static/media/842.8e6a3788.png";